import { render, staticRenderFns } from "./NotificationsWidgetItem.vue?vue&type=template&id=afaf076a&"
import script from "./NotificationsWidgetItem.vue?vue&type=script&lang=js&"
export * from "./NotificationsWidgetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports